<template>
  <div class="view-tasklists account-lookup-view-list">
    <user-menu />
    <div class="wrapper">
      <EnterpriseAdminSidebarMenu 
        :readOnly="isReadOnly"/>
      <div class="content-wrapper">
        <div class="container-wrapper center">
          <button
            class="btn btn-red btn-md input-height-15"
            @click="printWindow()">Print</button>
            <div id="locations-display">
              <div style="padding-left: 0px;width: 98%;font-size: 14px;">

               <div style="background-color: #FFF; margin-top: 15px;">
                        <b-card no-body class="manage_locations">
                            <div>                                
                                <h3 class="d-inline heading">Enterprise Account Activity</h3>
                            </div>
                            <div class="list_locations" style="padding: 20px;">
                               <div class="row enterprise-head-row">
                                    <div style="font-weight: bold;width: 40%;padding-left: 5px;float: left;">
                                        Event                                        
                                    </div>
                                    <div
                                        style="font-weight: bold;width: 20%;padding-left: 5px;float: left;">
                                        Admin                               
                                    </div>
                                    <div
                                        style="font-weight: bold;width: 20%;padding-left: 5px;float: left;">
                                        Date                                       
                                    </div>
                                    <div
                                        style="font-weight: bold;width: 15%;padding-left: 5px;float: left;">
                                        Time
                                    </div>
                                    
                                    
                                </div>
                                <div v-show="loading" class="loading_show"><div class="spinner-border text-danger"></div></div>
                                <div  class="row_items">
                                    <div class="row_data_border row" v-for="(activity, aindex) in activityData" :key="aindex" style="border-bottom: 1px solid rgba(0, 0, 0, 0.1); padding: 5px 0px;">
                                        <div style="width: 40%;padding-left: 5px;float: left;">{{activity.logMessage}}</div>
                                        <div style="width: 20%;padding-left: 5px;float: left;">{{activity.updatedBy}}</div>
                                        <div style="width: 20%;padding-left: 5px;float: left;">{{activity.updatedDate}}</div>
                                        <div style="width: 15%;padding-left: 5px;float: left;">
                                            {{activity.updatedTime}} (CST)
                                        </div>
                                        
                                        
                                        <div style="clear: both;"></div>
                                    </div>
                                </div>
                               
                            </div>
                                                                   
                        </b-card>
                    </div> 

            </div>    
            </div>
          </div> 
        </div>
      </div>
    </div>
</template>

<script>
import axios from 'axios';
import UserMenu from '../shared/user_menu.vue';
import EnterpriseAdminSidebarMenu from '../shared/enterpriseadmin_sidebar_menu.vue';
import { store } from '../../store/store';

export default {
        data() {
          return {            
            activityData: [],
            isReadOnly: false,
          }
        },
        components: {
            UserMenu,
            EnterpriseAdminSidebarMenu,
        },
        methods: {
          printWindow: function () {
            var printContents = document.getElementById('locations-display').innerHTML;
            var NewWin = window.open("", "PlatformReport");
            NewWin.document.write(printContents);
            NewWin.document.close();
            NewWin.print();
            NewWin.close();
          },
        },
        mounted() {
        },
        created() {            
            axios('/enterprise_account_activity',
            {
                method: 'GET',
            })
            .then(resp => {
                this.activityData = resp.data;                          
            })
            .catch(() => {
            });

            axios('/enterprise-admin-info',
            {
                method: 'GET',
            })
            .then(resp => {
                if (resp.data.account.enterprise_type === 'Readonly') {
                    this.isReadOnly = true;
                } else {
                    this.isReadOnly = false;
                }
            })
            .catch(() => {
            });
        },
    }
</script>




// WEBPACK FOOTER //
// src/components/enterpriseadmin/print_enterprise_accactivity.vue